import { render, staticRenderFns } from "./aroundme.vue?vue&type=template&id=10a8208a&"
import script from "./aroundme.vue?vue&type=script&lang=js&"
export * from "./aroundme.vue?vue&type=script&lang=js&"
import style0 from "./aroundme.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports